function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.6667 6.3335H17.1667C18.2712 6.3335 19.1667 7.22893 19.1667 8.3335V17.1668C19.1667 18.2714 18.2712 19.1668 17.1667 19.1668H8.33334C7.22877 19.1668 6.33334 18.2714 6.33334 17.1668V13.6668",
  stroke: "#32383D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6667 0.833496H2.83334C1.72877 0.833496 0.833344 1.72892 0.833344 2.83349V11.6668C0.833344 12.7714 1.72877 13.6668 2.83334 13.6668H11.6667C12.7712 13.6668 13.6667 12.7714 13.6667 11.6668V2.8335C13.6667 1.72893 12.7712 0.833496 11.6667 0.833496Z",
  stroke: "#32383D",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3d366f5d.svg";
export { ForwardRef as ReactComponent };